import { useEffect, useRef } from "react"

const useDebounce = (callback, delay, value = []) => {
    const latestCallback = useRef()
    const latestTimeout = useRef()

    const effectDependency = [...value, callback]
    useEffect(() => {
        latestCallback.current = callback
    }, effectDependency)

    return () => {
        if (latestTimeout.current) {
            clearTimeout(latestTimeout.current)
        }

        latestTimeout.current = setTimeout(() => {
            latestCallback.current()
        }, delay)
    }
}

export default useDebounce
